import { useSelector } from 'hooks/useSelector';
import React from 'react';
import {
  selectAseFieldInstanceAst,
  selectAseTplFieldInstanceCheck,
  selectAseTplFieldInstanceDefaultChecksForGroup,
} from 'store/assessments/selectors';
import { CardRow } from 'components/CardRow';
import { SeparatorHorizontal } from 'components/SeparatorHorizontal';
import { filterArrayEmpty, formatDate, numberToDate } from 'lib/riskbase';
import { UI_DATE_FORMAT_SHORT } from 'lib/constants';
import { FieldInstanceCheckScheduleStatusEnum } from 'store/assessments/types';

export const ExplorerInstanceCheckRowPreAdd: React.FC<{
  id: string;
  instanceId: string;
  hideCompleted: boolean;
}> = ({ id, instanceId, hideCompleted }) => {
  const check = useSelector((state) =>
    selectAseTplFieldInstanceCheck(state, id),
  );
  const instance = useSelector((state) =>
    selectAseFieldInstanceAst(state, instanceId),
  );
  const actualCheckData = instance?.checks?.[id];
  const defaultCheckData = useSelector((state) =>
    selectAseTplFieldInstanceDefaultChecksForGroup(
      state,
      instance?.groupId || '-1',
    ),
  )[id];
  const checkData = actualCheckData || defaultCheckData;

  if (
    !check ||
    !checkData ||
    (hideCompleted &&
      checkData.schedule.statusId ===
        FieldInstanceCheckScheduleStatusEnum.completed)
  ) {
    return null;
  }

  return (
    <>
      <SeparatorHorizontal />
      <CardRow
        label={`${check.name} ${
          checkData.schedule.statusId !==
          FieldInstanceCheckScheduleStatusEnum.completed
            ? 'Required' +
              `${
                checkData.schedule.due
                  ? ` (${[
                      checkData.schedule.due.from
                        ? formatDate(
                            numberToDate(checkData.schedule.due.from),
                            UI_DATE_FORMAT_SHORT,
                          )
                        : null,
                      checkData.schedule.due.to
                        ? formatDate(
                            numberToDate(checkData.schedule.due.to),
                            UI_DATE_FORMAT_SHORT,
                          )
                        : null,
                    ]
                      .filter(filterArrayEmpty)
                      .join(' – ')})`
                  : ''
              }`
            : 'Completed' +
              `${
                checkData.lastCompleted
                  ? ` (${formatDate(
                      numberToDate(checkData.lastCompleted.date),
                      UI_DATE_FORMAT_SHORT,
                    )})`
                  : ''
              }`
        }`}
        labelSize="xsmall"
        labelNumberOfLines={2}
        iconStyle={{ marginHorizontal: 2 }}
        style={{ minHeight: 0 }}
      />
    </>
  );
};
